/* ------------------------------------------------------------------------ */
/*		File: functions.ts                                                  */
/*		Description: Component interface definition                         */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */



export const getImage = (img: any) => {
    try {
        if (img === null) { return require(`../../img/transparent.svg`).default; }
        else if (img.includes("https")) { return img }
        else {return require(`../../img/${img}`);}
    } catch (err) {
        return require(`../../img/transparent.svg`).default;
    }
}